// SolutionsDropdown.jsx
import React, { useEffect, useState } from "react";
import "../styles/NavDropdown.css";
import { NavLink } from "react-router-dom";

function useIsMobile(breakpoint = 800) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);

  return isMobile;
}

export default function SolutionsDropdown() {
  const isMobile = useIsMobile(800);
  const [open, setOpen] = useState(false);

  const toggleDropdown = (e) => {
    if (!isMobile) return;
    e.preventDefault();
    setOpen((prev) => !prev);
  };

  const closeDropdown = () => {
    if (isMobile) setOpen(false);
  };

  useEffect(() => {
    if (!isMobile) setOpen(false);
  }, [isMobile]);

  return (
    <div className={`mega-wrapper ${open ? "is-open" : ""}`}>
      <div className="dropdown mega-dropdown">
        <button
          className="dropdown-toggle"
          onClick={toggleDropdown}
          aria-expanded={isMobile ? open : undefined}
          type="button"
        >
          Solutions
        </button>
      </div>

      <div className="mega-menu">
        <div className="mega-menu-inner">
          {/* LEFT INTRO */}
          <div className="mega-left">
            <h3>Solutions at Cloudare</h3>
            <p>
              End-to-end technology consulting, ERP support, and tax compliance
              solutions designed for global enterprises.
            </p>
            <NavLink to="/consultation" className="mega-link" onClick={closeDropdown}>
              Explore all solutions →
            </NavLink>
          </div>

          {/* CENTER */}
          <div className="mega-center">
            {/* ERP SUPPORT — routes normalized to lowercase */}
            <div className="mega-column">
              <h4>ERP Support</h4>
              <NavLink to="/services/oracle" onClick={closeDropdown}>
                Oracle Fusion / EBS
              </NavLink>
              <NavLink to="/services/netsuite" onClick={closeDropdown}>
                NetSuite
              </NavLink>
              <NavLink to="/services/zoho" onClick={closeDropdown}>
                Zoho
              </NavLink>
              <NavLink to="/services/odoo" onClick={closeDropdown}>
                Odoo
              </NavLink>
            </div>

            {/* TAX IMPLEMENTATION */}
            <div className="mega-column">
              <h4>E-Invoicing Implementation</h4>
              <NavLink to="/tax/uae" onClick={closeDropdown}>
                FTA UAE
              </NavLink>
              <NavLink to="/tax/ksa" onClick={closeDropdown}>
                ZATCA
              </NavLink>
              <NavLink to="/tax/malaysia" onClick={closeDropdown}>
                LHDN
              </NavLink>
              <NavLink to="/tax/india" onClick={closeDropdown}>
                GST
              </NavLink>
              <NavLink to="/tax/france" onClick={closeDropdown}>
                France
              </NavLink>
              <NavLink to="/tax/eu" onClick={closeDropdown}>
                EU PEPPOL
              </NavLink>
            </div>

            {/* HR */}
            <div className="mega-column">
              <h4>HR Services</h4>
              <NavLink to="/hire-talent" onClick={closeDropdown}>
                Hire Talent
              </NavLink>
              <NavLink to="/services/payroll" onClick={closeDropdown}>
                Payroll &amp; HR Solutions
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
